import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { setAuth, logout } from '../store/slices/authSlice';
import { requestOtp, verifyOtp, LoginRequest, VerifyOtpRequest, SendOtpResponse, restoreAuthFromStorage } from '../api/authApi';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, token } = useSelector((state: RootState) => state.auth);

  // Restore session on mount
  useEffect(() => {
    const { session_id, user } = restoreAuthFromStorage();
    if (session_id && user) {
      dispatch(setAuth({ user, token: session_id }));
    }
  }, [dispatch]);

  const login = useCallback(async (data: LoginRequest): Promise<SendOtpResponse> => {
    return requestOtp(data);
  }, []);

  const verifyOtpAndLogin = useCallback(async (data: VerifyOtpRequest) => {
    const response = await verifyOtp(data);
    // Persist user info in localStorage for session restore
    if (response.user) {
      localStorage.setItem('user', JSON.stringify(response.user));
      localStorage.setItem('session_id', response.session_id);
    }
    dispatch(setAuth({
      token: response.session_id, // session_id is now the token
      user: {
        id: response.user.id,
        phoneNumber: response.user.mobile, // Map mobile to phoneNumber
        full_name: response.user.full_name // Add full_name for display
      }
    }));
  }, [dispatch]);

  const logoutUser = useCallback(() => {
    dispatch(logout());
    localStorage.removeItem('session_id');
    localStorage.removeItem('user');
  }, [dispatch]);

  return {
    user,
    isAuthenticated,
    token,
    login,
    verifyOtpAndLogin,
    logout: logoutUser,
  };
};
